module.exports = __webpack_public_path__ + "img/image72.6b5e22e.jpg";